import * as React from "react";
import ConfigurationSettingsPage from "../configuration/ConfigurationSettingsPage";

const ConfigurationSettingsRoute: React.FC = () => (
  <ConfigurationSettingsPage />
);

export default ConfigurationSettingsRoute;
